import React, { useContext } from 'react';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import Config from '@skin_config';
import { useTranslation } from '@common/hooks/translation';
import { PopupContext } from '@app/dev/contexts/popup';
import { POPUPS } from '@common/constants/popups';

import './style.scss';

export const CasinoAdnLiveCasinoGame = ({ game, routePath }) => {
  const [{ openPopup }] = useContext(PopupContext);
  const navigate = useNavigate();
  const t = useTranslation();
  const user = useSelector((state) => state.user);

  const mandatoryLogin = () => {
    if (!user.loggedIn && Config.main.mandatoryCasinoLogin) {
      openPopup(POPUPS.SIGN_IN);
    } else {
      console.log('clickum em')
      navigate(`${routePath}/${game.id}`);
    }
  };

  return (
    <div className="casino-game-item-view" onClick={mandatoryLogin}>
      <div className="casino-game-info-view">
        <div className="casino-game-images-container">
          <img className="casino-game-images" src={game.icon_1 || game.icon_2} alt="game image" />
        </div>
        <div className="casino-games-box-bottom-row">
          <div className="casino-game-title-and-provider">
            <span className="casino-game-title">
              {t(game?.name)}
            </span>
            <span className="casino-game-provider">
              {t(game?.provider_title)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

CasinoAdnLiveCasinoGame.propTypes = {
  game: PropTypes.object,
  routePath: PropTypes.string,
};
